import React from "react";
import Table2 from "../Table2/Table2";
import select from "../../images/icons/pointer.png";
import External_In_Map from "../External_Visites/External_In_Map";
import FilterStatistics from "../Main/Statistics/FilterStatistics";
import { useSelectorCustom } from "../General/GeneralComponent/useSelectorCustom";
import {
  ColumnArrayMedicalRepTarget,
  VariableReports,
} from "./VariableReports";

function MedicalRepTargetReport({ langmiamed, t, navigate, setopenInternet }) {
  const { medicalRepTarget, loagingMedicalRepTarget } = useSelectorCustom();
  const reversedgeneralExReport = medicalRepTarget?.reverse();
  const { state, storeMap, setIsOpen } = VariableReports();
  const { medicalRepTargetColumn } = ColumnArrayMedicalRepTarget(t, storeMap);
  return (
    <>
      <FilterStatistics
        t={t}
        langmiamed={langmiamed}
        params="medical_rep_target_report"
        excel="medical_rep_target_report"
      />
      <div className="users" dir={langmiamed == "ar" ? "ltr" : "ltr"}>
        {loagingMedicalRepTarget == false ? (
          <Table2 col={medicalRepTargetColumn} roo={reversedgeneralExReport} />
        ) : (
          <div className="alternative">
            <img src={select} />
            <br></br>
            <p>{t("filterr")}</p>
          </div>
        )}
      </div>
      {state.openMap && (
        <External_In_Map
          open={state.openMap}
          setOpen={setIsOpen}
          lat={state.lat}
          lng={state.lng}
        />
      )}
    </>
  );
}

export default MedicalRepTargetReport;
